import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import Game from "./Game";

const SITE_KEY = "6LfF2WEsAAAAAEwWLGTorUoi6oNI7BgZxRUTrMt1";

const App = () => {
    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={SITE_KEY}
            scriptProps={{
                async: false,
                defer: false,
                nonce: undefined,
            }}
        >
            <Game />
        </GoogleReCaptchaProvider>
    )
}

export default App;
